import React from "react";
import GlobalApi from "../../Global";
import { Container, Grid, Typography, Paper,Button } from "@material-ui/core";
import blocked from '../../Assets/blocked.png';
import { DriveEtaTwoTone } from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import { Redirect } from "react-router";
import {useTranslation} from 'react-i18next';

export default function Blocked() {
  const {t} = useTranslation();
  const history = useHistory();

  
  async function logout() {
      let localstorage = localStorage.getItem("UserData");

      let data = JSON.parse(localstorage);
      fetch(GlobalApi + "/DeviceRecord/delete_device_record", {
        method: "post",
        headers: new Headers({
          Authorization: "Bearer " + data.token,
          "Content-Type": "application/json",
        }),
        body: JSON.stringify({
          device_record_id: data.device_id,
        }),
      })
        .then((res) => res.json())
        .then(async (resJson) => {
          console.log("DELETE RESPONSE IF DEVICE API", resJson);

          console.log("all Dispatches Called");
          // dispatch(removeUser());
          // dispatch(removeCompany());
          // dispatch(removeCompanyArr());
          // dispatch(removeIndustryArr());
          // 
          localStorage.clear();
          window.location.reload()
          // history.replace("/signin");
        })
        .catch((error) => console.log("error", error));
    
  }


  var retrievedData = localStorage.getItem("UserData");
  var data = JSON.parse(retrievedData);
  if (!data) {
    return <Redirect to={"/signin"} />;
  }else{
    return <div>
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", textAlign: "center" }}>
      <div>
        <img src={blocked} width={500} />
        <Typography variant="h4" style={{ fontWeight: "bolder", color: "red" }}>
          {t("Your Organizations Account has been blocked")}
        </Typography>
        <br />
        <br />

        <Typography variant="h5" style={{ fontWeight: "bolder" }}>
          {t("Don't Worry")}
        </Typography>
        <Typography variant="h6" style={{ fontSize: "18px", color: "#043077" }}>
          {t("We will help you reactivate your account")}
        </Typography>
        <Typography variant="h6" style={{ fontSize: "18px" }}>
          {t("Our Customer Support Team is Available 24/7")}
        </Typography>
        <br />
        <a href="https://www.uraudits.com" target="_blank">
        <Button className="addBtn" style={{ fontSize: 16 }}>
          {t("Contact Support Team")}
        </Button>
        </a>
        <Button className="cancelBtn" style={{ fontSize: 16,fontWeight:'bold', boxShadow:"0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)"  }} onClick={()=>logout()}>
          {t("Signin Now")}
        </Button>
      </div>
    </div>
  </div>;
  }

 
}
